import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { OfferSummaryDataService } from '../../../core/services/offer-summary-data.service';

@Component({
    selector: 'app-upload-cleared-offer-dialog',
    templateUrl: './upload-cleared-offer-dialog.component.html',
    styleUrls: ['./upload-cleared-offer-dialog.component.css']
})
export class UploadClearedOfferDialogComponent implements OnInit, AfterViewInit {
    @ViewChildren('input') vc;

    constructor(private fileUploadService: OfferSummaryDataService) { }

    @Input() portfolioId: string;
    @Input() tradingDate: string;
    @Input() product: string;
    @Output() buttonEvent = new EventEmitter<string>();

    fileToUpload: File = null;

    ngOnInit() {
    }

    ngAfterViewInit() {
        setTimeout(() => { this.vc.first.nativeElement.focus() });
    }

    handleFileInput(files: FileList) {
        this.fileToUpload = files.item(0);
    }

    uploadClicked() {
        if (this.fileToUpload) {
            this.fileUploadService.analyseFile(this.fileToUpload, this.portfolioId, this.tradingDate, this.product);
            this.buttonEvent.emit("Upload");
        }
    }

    cancelClicked() {
        this.buttonEvent.emit("Cancel");
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/upload-cleared-offer-dialog/upload-cleared-offer-dialog.component.ts